export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/app/src/pages/index.vue'),
    children: [
      {
        path: '',
        name: '//',
        component: () => import('/app/src/pages/index/index.vue'),
        /* no children */
      },
      {
        path: 'categories',
        /* internal name: '//categories' */
        /* no component */
        children: [
          {
            path: ':categoryId',
            name: '//categories/[categoryId]',
            component: () => import('/app/src/pages/index/categories/[categoryId].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'products',
        /* internal name: '//products' */
        /* no component */
        children: [
          {
            path: ':productId',
            name: '//products/[productId]',
            component: () => import('/app/src/pages/index/products/[productId].vue'),
            children: [
              {
                path: '',
                name: '//products/[productId]/',
                component: () => import('/app/src/pages/index/products/[productId]/index.vue'),
                /* no children */
              },
              {
                path: 'customizationType',
                name: '//products/[productId]/customizationType',
                component: () => import('/app/src/pages/index/products/[productId]/customizationType.vue'),
                /* no children */
              },
              {
                path: 'customize',
                name: '//products/[productId]/customize',
                component: () => import('/app/src/pages/index/products/[productId]/customize.vue'),
                /* no children */
              },
              {
                path: 'customize/:layerId',
                name: '//products/[productId]/customize.[layerId]',
                component: () => import('/app/src/pages/index/products/[productId]/customize.[layerId].vue'),
                /* no children */
              },
              {
                path: 'customize/colors',
                name: '//products/[productId]/customize.colors',
                component: () => import('/app/src/pages/index/products/[productId]/customize.colors.vue'),
                /* no children */
              },
              {
                path: 'customize/create',
                name: '//products/[productId]/customize.create',
                component: () => import('/app/src/pages/index/products/[productId]/customize.create.vue'),
                /* no children */
              },
              {
                path: 'customize/graduation',
                name: '//products/[productId]/customize.graduation',
                component: () => import('/app/src/pages/index/products/[productId]/customize.graduation.vue'),
                /* no children */
              },
              {
                path: 'customize/pattern',
                name: '//products/[productId]/customize.pattern',
                component: () => import('/app/src/pages/index/products/[productId]/customize.pattern.vue'),
                /* no children */
              },
              {
                path: 'details',
                name: '//products/[productId]/details',
                component: () => import('/app/src/pages/index/products/[productId]/details.vue'),
                /* no children */
              },
              {
                path: 'layouts',
                name: '//products/[productId]/layouts',
                component: () => import('/app/src/pages/index/products/[productId]/layouts.vue'),
                /* no children */
              },
              {
                path: 'summary',
                name: '//products/[productId]/summary',
                component: () => import('/app/src/pages/index/products/[productId]/summary.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'variants',
        /* internal name: '//variants' */
        /* no component */
        children: [
          {
            path: ':variantRef',
            name: '//variants/[variantRef]',
            component: () => import('/app/src/pages/index/variants/[variantRef].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/demo',
    name: '/demo',
    component: () => import('/app/src/pages/demo.vue'),
    /* no children */
  },
  {
    path: '/threeDemo',
    name: '/threeDemo',
    component: () => import('/app/src/pages/threeDemo.vue'),
    /* no children */
  }
]
